import { all, call } from 'redux-saga/effects';
import { sagas as list } from './listModule';

export default function* clusterSaga() {
	yield all([call(list)]);
}
